import styled from '@emotion/styled';
import { ButtonLink, ButtonLinkWithIcon } from '@kyruus/button';
import { fromTheme } from '@kyruus/ui-theme';

export const OpenSchedulingIFrame = styled.iframe`
  width: 100%;
  border: 0;
  height: 400px;
  margin-top: 12px;
`;

export const FullWidthButtonLink = styled(ButtonLink)`
  &&& {
    display: block;
    padding: 12px;
    margin-top: 12px;
    margin-bottom: 12px;
    text-align: center;
  }
`;

export const FullWidthButtonLinkWithIcon = styled(ButtonLinkWithIcon)`
  display: block;
  padding: 12px;
  margin-top: 12px;
  margin-bottom: 12px;
`;

const Heading = styled.h2`
  color: ${fromTheme('color_text')};
  font-size: ${fromTheme('font_size_heading_4')};
  font-weight: ${fromTheme('font_weight_bolder')};
  margin: 0;
  grid-area: title;
`;

export const ScheduleAppointmentHeading = Heading;

export const AppointmentsHeading = Heading;
